import AppContainer from '@/views/app/app-container'
import DashboardRouter from './dashboard'
import DealersRouter from './dealers'
import BranchesRouter from './branches'
import LayoutsRouter from './layouts'
import AssignmentsRouter from './assignments'
import PeriodsRouter from './periods'
import UsersRouter from './users'
import EvaluationsRouter from './evaluations'
import ReportsRouter from './reports'

export default [
  {
    path: '/app',
    name: 'App',
    component: AppContainer,
    children: [
      ...DashboardRouter,
      ...DealersRouter,
      ...BranchesRouter,
      ...LayoutsRouter,
      ...AssignmentsRouter,
      ...PeriodsRouter,
      ...UsersRouter,
      ...EvaluationsRouter,
      ...ReportsRouter
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/index.js